import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/common.model';

export interface AuditLogEntry {
  id: string;
  userId: string;
  userName: string;
  action: string;
  entityType: string;
  entityId: string | null;
  details: string | null;
  createdAt: string;
}

export interface PaginatedAuditLogs {
  logs: AuditLogEntry[];
  currentPage: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

@Injectable({ providedIn: 'root' })
export class AuditLogService {
  private apiUrl = `${environment.apiUrl}/auditlog`;

  constructor(private http: HttpClient) {}

  getLogs(
    page: number = 1,
    pageSize: number = 50,
    userId?: string,
    entityType?: string,
    action?: string,
    from?: string,
    to?: string
  ): Observable<ApiResponse<PaginatedAuditLogs>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (userId) params = params.set('userId', userId);
    if (entityType) params = params.set('entityType', entityType);
    if (action) params = params.set('action', action);
    if (from) params = params.set('from', from);
    if (to) params = params.set('to', to);

    return this.http.get<ApiResponse<PaginatedAuditLogs>>(this.apiUrl, { params });
  }
}
